import { render, staticRenderFns } from "./selectDigitalResources.vue?vue&type=template&id=2f1d97f8&"
import script from "./selectDigitalResources.vue?vue&type=script&lang=js&"
export * from "./selectDigitalResources.vue?vue&type=script&lang=js&"
import style0 from "./selectDigitalResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports